module.exports = __webpack_public_path__ + "img/logo-bej.a1ea4cde.svg";